import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类别浏览，快速找到你喜欢的韩漫类型</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="flex flex-col items-center gap-2 p-4 md:p-5 rounded-xl bg-background-50 hover:bg-primary-50 transition-all duration-300 group cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-all duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-600 group-hover:text-background-50 transition-all duration-300`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors duration-300 whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count}部</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}